import React, { FC, ReactNode } from 'react';
import { ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { Action } from 'components';
import { Action as ActionType } from 'api';
import { ListWidget } from '../';

interface IProps {
  title: string | ReactNode;
  results: ActionType[];
  link?: string;
}

const useStyles = makeStyles(theme => ({
  item: {
    padding: 0,
  },
  time: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

const ActivityWidget: FC<IProps> = props => {
  const { results, title, link } = props;
  const classes = useStyles();

  function renderActivity(action: ActionType) {
    if (!action) {
      return null;
    }

    return (
      <ListItem key={action.id} disableGutters>
        <ListItemText disableTypography className={classes.item}>
          <Typography variant="body2">
            <Action action={action} />
          </Typography>
          <Typography color="textSecondary" className={classes.time}>
            {moment.unix(action.created_at).fromNow()}
          </Typography>
        </ListItemText>
      </ListItem>
    );
  }

  return (
    <ListWidget color="primary" title={title} link={link}>
      {results.map(result => renderActivity(result))}
    </ListWidget>
  );
};

export default ActivityWidget;
